import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "./button";
import { HiddenOnDesktop, HiddenOnPhone } from "./hidden";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";

const ButtonWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: -1rem;
`;

const TabContent = styled.div`
  border-radius: var(--border-radius);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background-color: var(--color-white);
`;

const DropDown = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

const ActiveCategory = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-black);
  color: var(--color-white);
  padding: 1rem 1.5rem;
  border-radius: var(--border-radius);
`;

const HiddenPanel = styled.div`
  visibility: hidden;
  opacity: 0;
  max-height: 0;
  background-color: var(--color-white);
  border-radius: var(--border-radius);
  transition: all 0.3s ease-in-out;
  &.active {
    visibility: visible;
    opacity: 1;
    max-height: 1000px;
  }
  & * {
    margin: 0;
    padding: 1rem;
    &:first-child {
      padding-top: 1.5rem;
    }
    &:last-child {
      padding-bottom: 1.5rem;
    }
  }
`;

const Tabs = ({ titles, children }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [openPanel, setOpenPanel] = React.useState(false);

  const setActiveTitle = (index) => {
    setOpenPanel(false);
    setActiveIndex(index);
  };

  return (
    <div style={{ width: "100%" }}>
      <HiddenOnPhone style={{ maxWidth: "100%" }}>
        <ButtonWrapper>
          {titles.map((title, index) => (
            <Button
              onClick={() => setActiveIndex(index)}
              key={index}
              label={title}
              variant={index === activeIndex ? "filled" : "outlined"}
            />
          ))}
        </ButtonWrapper>
      </HiddenOnPhone>
      <HiddenOnDesktop>
        <DropDown>
          <ActiveCategory onClick={() => setOpenPanel(!openPanel)}>
            {titles[activeIndex]}{" "}
            <FontAwesomeIcon
              icon={openPanel ? faAngleUp : faAngleDown}
              size="1x"
            />
          </ActiveCategory>
          <HiddenPanel className={openPanel ? "active" : ""}>
            {titles.map((title, index) => (
              <p onClick={() => setActiveTitle(index)} key={index}>
                {title}
              </p>
            ))}
          </HiddenPanel>
        </DropDown>
      </HiddenOnDesktop>
      {React.Children.map(children, (child, index) => (
        <TabContent
          key={index}
          style={{ display: index === activeIndex ? "block" : "none" }}
        >
          {child}
        </TabContent>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

export default Tabs;
